(function () {
  if (window.__mSizeGuideMetafieldDelegate) return;
  window.__mSizeGuideMetafieldDelegate = true;

  addEventDelegate({
    selector: "[data-open-sizeguide-metafield]",
    handler: (e, target) => {
      e.preventDefault();
      const sectionId = target.dataset.sizeguideSection;
      if (!sectionId || typeof MinimogTheme === "undefined" || !MinimogTheme.Modal) return;
      const source = document.getElementById(`m-size-guide-content-${sectionId}`);
      if (!source) return;
      const inner = source.querySelector(".m-size-guide-metafield__inner");
      if (!inner || !inner.innerHTML.trim()) return;

      const modal = new MinimogTheme.Modal();
      const wrapper = document.createElement("div");
      wrapper.className = "m-size-guide-metafield-modal rte";
      wrapper.innerHTML = inner.innerHTML;

      const colorScheme =
        (source.dataset.colorScheme || "").trim() ||
        (wrapper.querySelector("[data-color-scheme]") &&
          wrapper.querySelector("[data-color-scheme]").dataset.colorScheme) ||
        "";

      modal.appendChild(wrapper);
      modal.setSizes(`m-size-guide-metafield m-gradient ${colorScheme}`.trim());
      modal.open();
    },
  });
})();
